const CompanyModal = (state = {
    isShow: false
}, action) => {
    switch (action.type.toString()) {
        case "showModal":
            return state = {
                isShow: true
            };
        case "closeModal":
            return state = {
                isShow: false
            };
        default:
            return state = false;
    }
};
export default CompanyModal






// WEBPACK FOOTER //
// ./src/reducers/CompanyModal.js